// @flow
import React, { useCallback } from 'react';
import classNames from 'classnames/bind';

import nope from 'app/common/lib/nope';
import { DotsLoader } from 'app/common/components/Loader';

import styles from './Counter.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  value: number,
  onChange?: (value: number) => void,
  loading?: boolean,
  disabled?: boolean,
  minValue?: number,
  maxValue?: number,
}

const Counter = ({
  value,
  onChange,
  loading,
  disabled,
  minValue = 1,
  maxValue = Number.MAX_VALUE,
}: Props) => {
  const handleInc = useCallback((e) => {
    e.preventDefault();
    if (typeof onChange === 'function') {
      onChange(value + 1);
    }
  }, [value, onChange]);

  const handleDec = useCallback((e) => {
    e.preventDefault();
    if (typeof onChange === 'function') {
      onChange(value - 1);
    }
  }, [value, onChange]);

  return (
    <div className={styles.root}>
      <button
        type="button"
        onClick={value <= minValue ? nope : handleDec}
        className={cx(
          styles.utton,
          styles.buttonLeft,
          { disabled: value <= minValue || disabled || loading },
        )}
      >
        {'−'}
      </button>
      <input
        value={value}
        className={cx(styles.input, { disabled: disabled || loading })}
        readOnly
      />
      <button
        type="button"
        onClick={handleInc}
        className={cx(
          styles.utton,
          styles.buttonRight,
          { disabled: value >= maxValue || disabled || loading },
        )}
      >
        {'+'}
      </button>
      {loading && <DotsLoader className={styles.loader} />}
    </div>
  );
};

export default Counter;
